import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import SearchInput from 'src/components/SearchInput/SearchInput'
import Table from 'src/components/Table/Table'
import { useUserAssets } from 'src/hooks/api'
import { User } from 'src/types'
import { filterAssets } from 'src/util/filters'
import AccessCell from './AccessCell'
import AssetLinkCell from './AssetLinkCell'

import './UserAssets.sass'

interface UserAssetsProps {
  value: string[]
  onChange: (ids: string[], isInitial?: boolean) => void
  handleUser: (user: User) => void
  user: User
}

const UserAssets = ({ value, onChange, user, handleUser }: UserAssetsProps) => {
  const { id } = useParams()
  const userAssets = useUserAssets(id)

  const [filter, setFilter] = useState('')
  const filteredAssets = useMemo(() => userAssets.filter(filterAssets(filter)), [userAssets, filter])

  const access = useMemo(() => new Set(value), [value])

  const userProvinces = user.provinces
  const canForce = user.turnUp === 'SI' && userProvinces.length
  const forced = useMemo(() => {
    if (!canForce) return new Set()
    return new Set(userAssets
      .filter(a => a.province?.length && userProvinces.includes(a.province?.toUpperCase()))
      .map(u => u.prinexId)
    )
  }, [userProvinces, userAssets, canForce])

  const toggle = (id: string) => {
    if (forced.has(id)) return // Can't change these
    const clone = new Set(value)
    clone.has(id) ? clone.delete(id) : clone.add(id)
    handleUser({ ...user, heritage: false })
    onChange(Array.from(clone))
  }

  useEffect(() => {
    // Initialise outside's value on initial load
    onChange(userAssets.filter(a => a.access).map(a => a.prinexId), true)
  }, [userAssets])

  return (
    <section id="user-actives">
      <SearchInput value={filter} onChange={setFilter} />

      <Table
        name={'assets'}
        data={filteredAssets}
        columns={[
          { name: 'prinexId', component: AssetLinkCell },
          { name: 'address' },
          {
            name: 'access',
            component: AccessCell,
            enabled: access,
            onChange: toggle,
            forceEnabled: forced,
            idField: 'prinexId'
          }
        ]}
      />
    </section>
  )
}

export default UserAssets
